import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../Auth/_redux/authRedux";

const initialListingsState = {
  activeTab: 0,
};

export const settingsSlice = createSlice({
  name: "settingsSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    setSettingsPageTabIndex: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setSettingsPageTabIndex } = settingsSlice.actions;
